import { createPaginator } from "@smithy/core";
import { GetPersonTrackingCommand, } from "../commands/GetPersonTrackingCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetPersonTracking = createPaginator(RekognitionClient, GetPersonTrackingCommand, "NextToken", "NextToken", "MaxResults");
